<template>
  <div :class="s.background" :style="backgroundStyle" v-sound>
    <div :class="s.title">
      <p>いらっしゃいませ！</p>
      <div :class="s.subtitle">
        <p>ご来店ありがとうございます<br>こちらからご注文いただけます</p>
      </div>
      <div :class="s.container">
        <button :class="s.closeButton" @click="createTableSessions">メニューを見る</button>
      </div>
    </div>
    <!-- <button :class="s.staffButton" @click="callStaff">スタッフ呼び出し</button> -->
  </div>
</template>

<script>
import { mapState } from 'vuex'; 

export default {
  data() {
    return {};
  },
  created() {
    const { uuid, user_id: userId } = this.$route.query;
    if (uuid && userId) {
      this.axios.post('/v1/auth/login-qr', {
        device_uuid: uuid,
        user_id: userId,
      })
        .then((response) => {
          const { user, dining_table_id: diningTableId } = response.data;
          
          // ログイン状態を保存
          this.$store.commit('user/login/setUser', user);
          this.$store.commit('user/login/setIsLogin', true);
          
          // テーブルIDを保存
          localStorage.setItem('diningTableID', diningTableId);
          // デバイスUUIDを保存
          localStorage.setItem('deviceUUID', uuid);
          // QRコードセッションフラグを保存
          localStorage.setItem('isQrSession', 'true');
          
          // URLパラメータを削除してリロード（確実にログイン状態を反映させるため）
          window.location.href = '/';
        })
        .catch((error) => {
          console.error('QR login failed:', error);
          alert('QRコードの読み込みに失敗しました。');
        });
    }

    this.axios({
      method: 'GET',
      url: '/v1/connection/test',
    })
      .then((response) => {
        console.log(response.data.status);
      })
      .catch((error) => {
        if (error.response) console.log(error.response.data);
        else console.log(error);
      });
  },
  computed: {
    ...mapState(['user', 'cart', 'helper']),

    backgroundStyle() {
      const defaultUrl = "url('/img/backgrounds/default.PNG')";
      if (this.user && this.user.id) {
        return {
          backgroundImage: `url('/img/backgrounds/user_${this.user.id}.jpg'), ${defaultUrl}`,
        };
      }
      return {
        backgroundImage: defaultUrl,
      };
    },
  },
  methods: {
    createTableSessions() {
      // ログインしていない場合はログインページへリダイレクト
      if (!this.user.id) {
        alert('ログインしていません。ログインページへリダイレクトします。');
        this.$router.push('/login');
        return;
      }
      // テーブルID チェック
      const diningTableID = localStorage.getItem('diningTableID');
      if (!diningTableID || diningTableID === 'undefined') {
        alert('このデバイスは登録されていません。管理ページで登録してください。\nまたはQRコードを再度読み込んでください。');
        return;
      } 
      this.axios({
        method: 'POST',
        url: '/v1/tablesession/create',
        data: {
          dining_table_id: diningTableID,
          status: 0,
          user_id: this.user.id,
        },
      })
        .then((res) => {
          if (res.data.exists) {
            console.log('table session already exists');
          }
          console.log(res.data);
          this.$store.dispatch('cart/reset', { root: true });
          if (window.innerWidth <= 768) {
            this.$router.push('/menu-mobile');
          } else {
            this.$router.push('/menu');
          }
        })
        .catch((error) => {
          if (error.response) console.log(error.response);
          else console.log(error);
        });
    },
    callStaff() {
      // /staff-called ページに遷移
      this.$router.push('/staff-called');
    },
  },
};
</script>

<style lang="scss" module="s">
.background {
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  width: 100vw;
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
}

.title {
  color: #fffffff0;
  font-family: 'HGS明朝B', 'HGS明朝E', 'HGS明朝C', serif;
  font-size: 80px;
  text-align: center;
  font-weight: bold;
  line-height: 1.2;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  margin-top: 5vh;
  z-index: 1;
  position: relative;
}

.subtitle {
  color: #FFFFFF;
  font-family: '游明朝', serif;
  font-size: 42px;
  text-align: center;
  font-weight: bold;
  line-height: 1.4;
  margin-top: 20px;
}

.closeButton {
  background-color: #953127;
  color: #FFFFFF;
  font-family: 'HGS明朝B', 'HGS明朝E', 'HGS明朝C', serif;
  font-size: 36px;
  padding: 22px 90px;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  transition: background-color 0.3s, transform 0.2s;
  outline: none;
}

.closeButton:hover {
  background-color: #A32A2E;
  transform: scale(1.05);
}

.staffButton {
  position: absolute;
  bottom: 3%;
  right: 2%;
  background-color: #953127;
  color: #FFFFFF;
  font-family: 'HGS明朝B', 'HGS明朝E', 'HGS明朝C', serif;
  font-size: 26px;
  padding: 12px 40px;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  transition: background-color 0.3s, transform 0.2s;
  outline: none;
  z-index: 10;
}

.staffButton:hover {
  background-color: #A32A2E;
  transform: scale(1.05);
}

  @media (max-width: 576px) {
    .title {
      font-size: 40px;
    }
    .subtitle {
      font-size: 25px;
    }
    .closeButton {
      font-size: 20px;
      padding: 16px 60px;
      margin-top: 20%;
    }
    .staffButton {
      font-size: 20px;
      padding: 10px 30px;
    }
}
</style>
